export default function clone<T>(obj: T): T {
	return Object.assign(Object.create(Object.getPrototypeOf(obj)), obj);
}
